import * as React from 'react';

import {Route, useHistory} from 'react-router-dom';

import loadable from '@loadable/component';

import {List} from '@common/typescript/objects/List';

import {loadableDelay, params} from '@common/react/loadable/loadableSettings';
import {Loading} from '@common/react/components/UI/Loading/Loading';

import '@app/scss/components/blog.scss';

import {rest} from '@app/components/Api';
import {ResourceTopic} from '@app/objects/ResourceTopic';
import MustheadBadge from '@app/components/UI/MustHead/MustheadBadge';
import MustheadNaked from '@app/components/UI/MustHead/MustheadNaked';
import SidebarWithCaptions from '@app/components/UI/SidebarWithCaptions/SidebarWithCaptions';
import {ContentCategory} from '@app/objects/ContentCategory';
import {ContentCategories} from '@app/objects/ContentCategories';
import {ContentEntity, ContentTopicList} from '@app/objects/ContentTopic';
import {Issues} from '@app/objects/Questions';
import MobileMenuSlideInMenu from '@app/components/UI/MobileSlideInMenu/MobileSlideInMenu';
import Musthead from '@app/components/UI/MustHead/Musthead';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

const CatsAnxiety = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "CatsAnxiety" */ '@app/components/Pages/Resources/CommonDiseases/CatsAnxiety/CatsAnxiety')), params);
const FRBlog = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "FRBlog" */ '@app/components/Pages/Resources/FamilyResources/FRBlog')), params);
const FRVideos = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "FRVideos" */ '@app/components/Pages/Resources/FamilyResources/FRVideos')), params);
const ResourceCenter = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "ResourceCenter" */ '@app/components/Pages/Resources/FamilyResources/ResourceCenter')), params);
const FRFaq = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "FRFaq" */ '@app/components/Pages/Resources/FamilyResources/FRFaq')), params);
const ResourcesPage = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "ResourcesPage" */ '@app/components/Pages/Resources/FamilyResources/ResourcesPage')), params);

const FamilyResources = (props) => {
	const {match} = props;
	const history = useHistory();
	const [currentTopic, setCurrentTopic] = React.useState<ResourceTopic>();
	const [topics, setTopics] = React.useState<ResourceTopic[]>();
	const [currentIndex, setCurrentIndex] = React.useState(0);
	const [navCollapse, setNavCollapse] = React.useState(false);
	const [currentCategoryBlog, setCurrentCategoryBlog] = React.useState<ContentCategory>();
	const [categoriesBlog, setCategoriesBlog] = React.useState<ContentCategory[]>();
	const [topicsResource, setTopicsResource] = React.useState<ResourceTopic[]>();

	const [categoriesFAQ, setCategoriesFAQ] = React.useState<Issues[]>([]);
	const [currentCategoryFAQ, setCurrentCategoryFAQ] = React.useState<Issues>();
	const [currentCategorySimple, setCurrentCategorySimple] = React.useState();
	const [searchQuery, setSearchQuery] = React.useState();

	const [searchFieldValue, setSearchFieldValue] = React.useState('');
	const initArticleCount = 10;
	const [articleCount, setArticleCount] = React.useState<number>(initArticleCount);
	const [totalArticleCount, setArticleTotalCount] = React.useState<number>(0);

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const onSetCategory = (category) => {
		if (category.url === 'blog') {
			setCurrentCategoryBlog({
				id: 0,
				name: '',
				topics: [],
				url: ''
			});
		} else {
			setCurrentCategoryBlog(category);
		}

		setArticleCount(initArticleCount);
	};
	const onSetCategoryFaq = (category) => {
		if (category.name === 'FAQ') {
			setCurrentCategoryFAQ({
				name: '',
				questions: []
			});
		} else {
			setCurrentCategoryFAQ(category);
		}
	};

	const onSetCategorySimple = (category) => {
		setCurrentCategorySimple(category.url);
	};

	const CategoryHandlers = {
		HowIKnow: onSetCategorySimple,
		Calendar: onSetCategorySimple,
		Blog: onSetCategory,
		FAQ: onSetCategoryFaq,
		Videos: onSetCategory,
		Common: onSetCategory,
		Newsletter: onSetCategory
	};

	const imageAlts = {
		'common-diseases-in-cats': 'Common diseases in cats',
		'common-diseases-in-dogs': 'Common diseases in dogs',
		'symptom-management': 'Symptom management in pets'
	};

	React.useEffect(() => {
		setIsLoading(true);

		rest.get<List<ResourceTopic>>('v1/resourceTopics')
			.then((res) => {
				setTopics(res.list);
				const current = history.location.pathname.split('/').slice(2).join();
				const position = res.list.findIndex((el, ind, arr) => el.url === current);
				setCurrentIndex(position);
			});

		rest.get<ResourceTopic>(`v1/resourceTopics/${match.params.topic || ''}`)
			.then((res) => {
				setCurrentTopic(res);

				setIsLoading(false);
			});

	}, [match.params.topic]);

	React.useEffect(() => {

		const mql = window.matchMedia('screen and (max-width: 768px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setNavCollapse(true);
			} else {
				setNavCollapse(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);

		if (topics && topics.length > currentIndex) {
			setCurrentTopic(topics[currentIndex]);
		}
	}, [currentIndex]);

	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.querySelector('#react-app')?.scrollTo(0, 0);

		rest.get<List<ResourceTopic>>('v1/resourceTopics')
			.then(res => setTopicsResource(res.list));

	}, []);

	// меню -- категории в блоге
	React.useEffect(() => {
		rest.get<ContentCategories>('v2/contentTopics/blog')
			.then((res) => {
				setCategoriesBlog(res.list);
			});
	}, []);

	React.useEffect(() => {
		// @ts-ignore
		if (props.match.params.id && !(currentCategoryFAQ && currentCategoryFAQ.name)) {
			if (categoriesFAQ) {
				categoriesFAQ.forEach((item) => {
					// @ts-ignore
					if (item.name.replace(/\s+/g, '-') === props.match.params.id) {
						onSetCategoryFaq(item);
						return false;
					}
				});
			}
		}
	});

	React.useEffect(() => {
		rest.get<List<Issues>>('v1/faqCategories/').then(res => setCategoriesFAQ(res.list));
	}, []);

	const onSearchSubmit = (value) => {
		setSearchQuery(value);
		setSearchFieldValue(value);
	};

	return (
		<>
			{isLoading && <Loading />}
			{
				match.path === '/resource-center/:topic/:resource' ? null :

					!isLoading && <div>
						{
							match.path === '/resource-center/:topic' ?
								<MustheadBadge
									title={currentTopic?.title ?? 'Determining your pet\'s quality of life'}
									readMorePath="/how-will-i-know-it-is-time"
									readMoreTitle="Read more about Quality of Life"
									imageSrc={currentTopic?.avatar ?? require('@app/content/bulldog.jpg')}
									imageAlt={imageAlts[currentTopic?.url!]}
								/>
								: match.path === '/faq/:id?' || match.path === '/faq' ?

								<MustheadNaked imageSrc={require('@app/images/blog-bg.jpg')} title="Frequently Asked Questions"/>
								:
								match.path === '/resource-center' ?
								<Musthead imageSrc={require('@app/content/Resource-Center.jpg')} title="Educational Resources" imageAlt="Senior pet resources" />
								:
									match.path === '/videos' ?
								<MustheadNaked imageSrc={require('@app/images/blog-bg.jpg')} title="Lap of Love Videos"/>
								:
								<MustheadNaked imageSrc={require('@app/images/blog-bg.jpg')} title="Senior Pet Care Blog"/>
						}
						<div className="blog-page">
							<div className="blog-page-body">
								<MobileMenuSlideInMenu
									topics={topicsResource}
									onSetIssue={CategoryHandlers}
									topicsInner={{Blog: categoriesBlog, FAQ: categoriesFAQ}}
									typeTopicsInner={match.url.split('/')[1]}
									onSubmit={onSearchSubmit}
									searchFieldValue={searchFieldValue}
									setSearchFieldValue={setSearchFieldValue}
								/>
								<div className="blog-page__sidebar">
									<SidebarWithCaptions
										onSetIssue={CategoryHandlers}
										navCollapse={navCollapse}
										topics={topicsResource}
										withSubmit={false}
										searchFieldName={'searchFieldName'} searchFieldPlaceHolder={'Search by topic'}
										topicsInner={{Blog: categoriesBlog, FAQ: categoriesFAQ}}
										typeTopicsInner={match.url.split('/')[1]}
										onSubmit={onSearchSubmit}
										searchFieldValue={searchFieldValue}
										setSearchFieldValue={setSearchFieldValue}
									/>
								</div>
								<Route exact path = "/blog/:id?" >
									<FRBlog
										match={match}
										currentCategoryBlog={currentCategoryBlog}
										categoriesBlog={categoriesBlog}
										onSetCategory={onSetCategory}
										searchQuery={searchQuery}
										articleCount={articleCount}
										setArticleCount={setArticleCount}
										totalArticleCount={totalArticleCount}
									/>
								</Route>
								<Route exact path = "/videos">
									<FRVideos
										searchQuery={searchQuery}
									/>
								</Route>
								<Route exact path = "/resource-center">
									<ResourcesPage />
								</Route>
								<Route exact path = "/resource-center/:topic">
									<ResourceCenter
										match={match}
										searchQuery={searchQuery}
									/>
								</Route>
								<Route exact path = "/faq/:id?">
									<FRFaq
										match={match}
										categoriesFAQ={categoriesFAQ}
										setCategoriesFAQ={setCategoriesFAQ}
										currentCategoryFAQ={currentCategoryFAQ}
										setCurrentCategoryFAQ={setCurrentCategoryFAQ}
										searchQuery={searchQuery}
									/>
								</Route>

							</div>
						</div>
					</div>
			}
			<Route exact path = "/resource-center/:topic/:resource">
				<CatsAnxiety match={match} />
			</Route>
		</>
	);
};

export default FamilyResources;